import {CheckCircle as InvertSelectionIcon} from 'react-bootstrap-icons';

export type invertSelectionEvent = () => void

interface InvertSelectionProps {
    invertSelectionEvent : invertSelectionEvent
}

export const InvertSelection = ({invertSelectionEvent} : InvertSelectionProps) =>
{
    function fireInvertSelectionEvent()
    {
        if (invertSelectionEvent !== undefined) {
            invertSelectionEvent();
        }
    }

    return (
        <span className={"invert-selection btn btn-link p-0 align-bottom"} >
            <InvertSelectionIcon className="align-middle" onClick={fireInvertSelectionEvent} title="Invert selection"/>
        </span>
    )
}
